import xtend from 'xtend';
import { EventEmitter as EE } from 'events';

function Bus () {
    var emitter = new EE();

    function bus () {
        return emitter.apply(emitter, arguments);
    }

    bus.on = emitter.on.bind(emitter);

    function emitAction (type, data) {
        emitter.emit('snack', xtend(data, { type: type }));
    }
    bus.emitInfo = emitAction.bind(null, 'info');
    bus.emitError = emitAction.bind(null, 'error');
    bus.emitWarning = emitAction.bind(null, 'warning');
    bus.emitSuccess = emitAction.bind(null, 'success');
    bus.emitSnack = emitter.emit.bind(emitter, 'snack');

    return bus;
}

export default Bus();
